export const MANAGE_EXTRA_ACTIVITY_MODES = {
	add: 'add',
	manage: 'manage',
};

export const DEFAULT_EXTRA_ACTIVITY_DURATION = '00:15';
export const DEFAULT_SIGN_ON_EXTRA_ACTIVITY_DURATION = '00:35';

export const WORK_ASSIGNMENT_EXTRA_ACTIVITY_SUCCESS_RESPONSE =
	'WorkAssignmentExtraActivitySuccessResponse';
export const WORK_ASSIGNMENT_EXTRA_ACTIVITY_ERROR_RESPONSE =
	'WorkAssignmentExtraActivityErrorResponse';
